import React from "react";
import { Divider } from "antd";
import "./style/app-categories.scss";
import "./style/import-app.scss";
import Search from "antd/lib/input/Search";

interface Iprops {
  onClick: (category: string) => void;
  allCatagories: any[];
  activeTab: string;
  setSearchVal: (value: string) => void;
}

export const AppCategories: React.FC<Iprops> = ({
  onClick,
  allCatagories,
  activeTab,
  setSearchVal
}) => {
  return (
    <>
      <div className="tabs">
        {allCatagories.map((category: string, index: number) => (
          <button
            data-test-id={`categories_${category}`}
            key={index}
            id="active-tab-modal"
            className={`tab ${category === activeTab ? "active active-tab-footer" : ""}`}
            onClick={() => onClick(category)}
          >
            {category}
          </button>
        ))}
        <div className="right">
          {
            activeTab !== "Upload Apps" && 
            <Search
              placeholder="Search App"
              onSearch={value => setSearchVal(value)}
              style={{ width: 200, height: "26px" }}
              className="apps-modal-ant-input"
            />
          } 
        </div>
      </div>
      <Divider style={{ margin: "10px 0" }} />
    </>
  );
};
